var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('a',{staticClass:"avatar"},[_c('img',{attrs:{"src":_vm.data['图片']}})]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.data.name))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.data.company))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.data.position))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-41958f0b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/personage/personage.vue
// module id = yQwe
// module chunks = 0